import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { fetchBokCategories,addNewBook } from "../../../services/operations/bookDetais";
import { FaBook } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux"
import addbook from "../../../assets/addbook.png"
import { setBook } from "../../../redux/slices/bookSlice";
import { setCategories } from "../../../redux/slices/categorySlice";



function AddBook() {

  const [courseCategories, setCourseCategories] = useState([]);

  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const { book, editBook } = useSelector((state) => state.book)

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors,isSubmitSuccessful },
  } = useForm();

  useEffect(() => {
    const getCategories = async () => {
      setLoading(true);
      const categories = await fetchBokCategories();
      // console.log("categories", categories)

      if (categories.length > 0) {
        // console.log("categories", categories)
        setCourseCategories(categories);
      }
      setLoading(false);
    };
    getCategories();
  }, []);

  const onSubmit = async (data) => {
    // console.log(token)
    // console.log(data)
   
    const formData = new FormData()
    formData.append("bookName",data.bookName)
    formData.append("authorName",data.bookAuthor)
    formData.append("bookPublisherName",data.bookPublisherName)
    formData.append("bookID",data.bookID)
    formData.append("bookAddDate",data.bookAddDate)
    formData.append("category",data.category)
    formData.append("edition",data.edition)
    formData.append("bookPublishDate",data.bookPublishDate)
    console.log(data);

    setLoading(true)
    
    const result = await addNewBook(formData, token)
    // console.log(result)
    if (result) {
      dispatch(setBook(result))
    }
    setLoading(false)


  };

  useEffect(()=>{
    if(isSubmitSuccessful){
      reset({
        bookName:"",
        bookAuthor:"",
        bookPublisherName:"",
        bookID:"",
        bookAddDate:"",
        category:"",
        edition:"",
        bookPublishDate:"",
      })
    }

  },[reset,isSubmitSuccessful])

  return (
    <div className="">
      <div className="flex flex-col gap-8 bg-richblack-200 p-4 rounded-xl ">
      
      <div className="flex relative justify-between">
      <h1 className="text-2xl font-mulish font-bold">Add New Book </h1>
      <img className=" "
      src={addbook} 
      width={50}
      alt="" />
      </div>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="space-y-5 rounded-md border-[1px] border-richblack-700 bg-transparent p-2"
        >
          {/* First Row */}
          <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
            {/* Book Title */}
            <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%]">
              <label
                className="text-sm text-richblack-900"
                htmlFor="bookName"
              >
                Book Name <sup className="text-red">*</sup>
              </label>
              <input
                id="bookName"
                placeholder="Enter Book Name"
                {...register("bookName", { required: true })}
                className="two-style "
              />
              {errors.bookName && (
                <span className="ml-2 text-xs tracking-wide text-red">
                  Book Name is required
                </span>
              )}
            </div>

            {/* Book Author */}
            <div className="flex flex-col space-y-2 lg:lg:w-[47%]  w-full md:w-[47%]">
              <label
                className="text-sm text-richblack-900"
                htmlFor="bookAuthor"
              >
                Book Author <sup className="text-red">*</sup>
              </label>
              <input
                id="bookAuthor"
                placeholder="Enter Book Author"
                {...register("bookAuthor", { required: true })}
                className="two-style"
              />
              {errors.bookAuthor && (
                <span className="ml-2 text-xs tracking-wide text-red">
                  Book Author is required
                </span>
              )}
            </div>
          </div>
          {/* second row */}
          <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
            {/* Book Publisher */}
            <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%] ">
              <label
                className="text-sm text-richblack-900"
                htmlFor="bookPublisherName"
              >
                Book Publisher Name <sup className="text-red">*</sup>
              </label>
              <input
                id="bookPublisherName"
                placeholder="Enter Pubhisher Name"
                {...register("bookPublisherName", { required: true })}
                className="two-style "
              />
              {errors.bookPublisherName && (
                <span className="ml-2 text-xs tracking-wide text-red">
                  Book Publisher is required
                </span>
              )}
            </div>

            {/* Book bookID */}
            <div className="flex flex-col space-y-2 lg:lg:w-[47%]  w-full md:w-[47%]">
              <label className="text-sm text-richblack-900" htmlFor="bookID">
                Book Id <sup className="text-red">*</sup>
              </label>
              <input
                id="bookID"
                type="number"
                placeholder="Enter Book ID"
                {...register("bookID", { required: true })}
                className="two-style"
              />
              {errors.bookID && (
                <span className="ml-2 text-xs tracking-wide text-red">
                  Book bookID is required
                </span>
              )}
            </div>
          </div>

          {/* 3rd Row */}
          <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
            {/* Book Add Date */}
            <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%] ">
              <label
                className="text-sm text-richblack-900"
                htmlFor="bookAddDate"
              >
                Book Add Date <sup className="text-red">*</sup>
              </label>
              <input
                id="bookAddDate"
                type="date"
                {...register("bookAddDate", { required: true })}
                className="two-style "
              />
              {errors.bookAddDate && (
                <span className="ml-2 text-xs tracking-wide text-red">
                  Book Date is required
                </span>
              )}
            </div>

            {/* Book Cetegory */}
            <div className="flex flex-col space-y-2 lg:lg:w-[47%]  w-full md:w-[47%]">
              <label className="text-sm text-richblack-900" htmlFor="category">
                Book Catlog <sup className="text-red">*</sup>
              </label>
              <select
                {...register("category", { required: true })}
                defaultValue=""
                id="category"
                className="form-style w-full"
              >
                <option value="" disabled>``
                  Choose a Catlog
                </option>
                {!loading &&
                  courseCategories?.map((category) => (
                    <option key={category?._id} value={category?._id}>
                      {category?.name}
                    </option>
                  ))}
              </select>

              {errors.category && (
                <span className="ml-2 text-xs tracking-wide text-red">
                  Book bookID is required
                </span>
              )}
            </div>
          </div>

          {/* 4th row */}
          <div className="flex lg:gap-10 flex-wrap gap-4 w-full  ">
            {/* Book edition */}
            <div className="flex flex-col space-y-2  lg:lg:w-[47%]  w-full md:w-[47%] ">
              <label className="text-sm text-richblack-900" htmlFor="edition">
                Book edition <sup className="text-red">*</sup>
              </label>
              <input
                id="edition"
                placeholder="Enter Pubhisher Title"
                {...register("edition", { required: true })}
                className="two-style "
              />
              {errors.edition && (
                <span className="ml-2 text-xs tracking-wide text-red">
                  Book edition is required
                </span>
              )}
            </div>

            {/* Book bookPublishDate */}
            <div className="flex flex-col space-y-2 lg:lg:w-[47%]  w-full md:w-[47%]">
              <label
                className="text-sm text-richblack-900"
                htmlFor="bookPublishDate"
              >
                Book Publish date <sup className="text-red">*</sup>
              </label>
              <input
                id="bookPublishDate"
                type="date"
                placeholder="Enter Book ID"
                {...register("bookPublishDate", { required: true })}
                className="two-style"
              />
              {errors.bookPublishDate && (
                <span className="ml-2 text-xs tracking-wide text-red">
                  Book bookID is required
                </span>
              )}
            </div>
          </div>

         <div className="w-full flex lg:justify-center pt-4">
              <button className="flex items-center gap-x-1 p-2 px-4 bg-yellow-100 rounded-xl font-mulish font-semibold hover:bg-yellow-50">
                <FaBook /> <span>Submit Book</span>
              </button>

         </div>
        </form>
      </div>
      
    </div>
  );
}

export default AddBook;
